import { makeStyles } from '@mui/styles';

export const useHistoryLogStyles = makeStyles(() => ({
    root: {
        paddingLeft: 4,
        paddingRight: 4,
    },
}));
